import React, { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { Navigate, Outlet, useLocation } from 'react-router-dom'

export const PrivateRoutes = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { pathname } = useLocation()

  return (
    isAuthenticated ?
      <Outlet /> :
      <Navigate to={`/signin?redirect=${pathname}`} />
  );
};